import React from "react"
import { Switch } from "antd"
import { truncate } from "lodash"
import pencilBlue from "../../../images/pencil-blue.svg"
import removeIcon from "../../../images/remove_icon.svg"
import checkIcon from "../../../images/check-measure.svg"
import { ROLE_COMPANY_SUPER_ADMIN } from "../../../utils/constants"
import {
  LOCAL_ACTIVE_ROL,
  LOCAL_USER_ID,
  isAdminMandu,
} from "../../../utils/storage"
import { buttonAction_btns } from "../../../components/Snowplow/config2"

export default (setStateFrom, switchUserWatcher) => {
  return [
    {
      title: "Usuario",
      width: 280,
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Colaborador",
      width: 280,
      dataIndex: "first_name",
      key: "first_name",
      render: (text, record) => {
        return truncate(
          `${text} ${record.last_name} ${record.second_last_name}`,
          { length: 32 }
        )
      },
    },
    {
      title: "División",
      dataIndex: "division",
      width: 280,
      key: "division",
      render: (text) => {
        if (!text) return "-"

        return text
      },
    },
    {
      title: "Superadministrador",
      width: 280,
      render: (_, record) => {
        return (
          <div className="container-usermanagement__superadmin-actions">
            {LOCAL_ACTIVE_ROL() == ROLE_COMPANY_SUPER_ADMIN ||
            isAdminMandu() ? (
              <React.Fragment>
                <Switch
                  disabled={record.id == LOCAL_USER_ID()}
                  checked={record.isCompanySuperAdmin}
                  onChange={(e) =>
                    switchUserWatcher({
                      idUser: record.id,
                      is_superadmin: Number(e),
                    })
                  }
                />
                <div className="container-usermanagement__superadmin-actions-right">
                  <img
                    src={pencilBlue}
                    onClick={() => {
                      setStateFrom("userSelected", record)
                      setStateFrom("modalCreateUser", true)
                      buttonAction_btns("Editar administrador")
                    }}
                  />
                  <img
                    src={removeIcon}
                    className={
                      record.id == LOCAL_USER_ID() ? "delete-icon" : ""
                    }
                    onClick={() => {
                      if (record.id == LOCAL_USER_ID()) return
                      setStateFrom("userSelected", record)
                      setStateFrom("modalDeleteSimple", true)
                    }}
                  />
                </div>
              </React.Fragment>
            ) : record.id_role == ROLE_COMPANY_SUPER_ADMIN ? (
              <img src={checkIcon} style={{ width: 12, height: 11 }} />
            ) : (
              ""
            )}
          </div>
        )
      },
    },
  ]
}
